// extracted by mini-css-extract-plugin
module.exports = {"regular-horizontal":"columna_regular-horizontal__zzXxA","mb-500":"columna_mb-500__MJmEG"};